import { computed } from 'vue'
import { freezeObject, isFunction } from '@/global/utils/utils'
import TabActionButtons from '@/global/components/view-layouts/tabs-layout/components/TabActionButtons.vue'
import SubcontractorDetailsInfo from '@/modules/road-maintenance-module/winter-service-v2/subcontractors/components/SubcontractorDetailsInfo.vue'
import { useSubcontractorFields } from '@/modules/road-maintenance-module/winter-service-v2/subcontractors/composables/useSubcontractorFields'
import { applyProviderStatusToPayload } from '@/modules/road-maintenance-module/winter-service-v2/common/composables/providerData'
import { WINTER_SERVICE_MODULE } from '@/modules/road-maintenance-module/winter-service-v2/common/config/constants'
import {
  SUBCONTRACTORS_ENDPOINT,
  SUBCONTRACTORS_TRANSLATION_NAMESPACE as NS,
  SUBCONTRACTOR_DETAILS_ROUTE
} from '@/modules/road-maintenance-module/winter-service-v2/subcontractors/config/constants'

const TAB_KEY = 'subcontractor_create'

export function useSubcontractorCreate (options) {
  const {
    translate,
    router,
    openGeolocationDialogFn,
    onCancelCreate
  } = options || {}

  const { fields } = useSubcontractorFields({
    translate,
    openGeolocationDialogFn
  })

  const apiConfig = freezeObject({
    post: {
      module: WINTER_SERVICE_MODULE,
      route: SUBCONTRACTORS_ENDPOINT
    }
  })

  const onCancelTabSave = (event) => {
    const { cancelTabSave } = event || {}

    if (isFunction(cancelTabSave)) {
      cancelTabSave()
    }

    if (isFunction(onCancelCreate)) {
      onCancelCreate()
    }
  }

  const redirectToDetails = (event, data) => {
    const { id } = data || {}
    if (!id) {
      return
    }

    router.push({
      name: SUBCONTRACTOR_DETAILS_ROUTE,
      params: {
        id: String(id)
      }
    })
  }

  const tabActions = computed(() => ({
    component: TabActionButtons,
    title: translate(`${NS}.new_subcontractor`),
    showEditButtons: true,
    onCancelTabSave
  }))

  // See useSubcontractorDetails - `rows` is what Content.vue reads to build the
  // save payload, so the fields have to live there.
  const infoBlock = computed(() => ({
    component: SubcontractorDetailsInfo,
    visible: true,
    rows: [
      {
        type: 'fields',
        columnsCount: 1,
        fields: fields.value
      }
    ]
  }))

  return computed(() => ({
    containerStyle: {
      padding: 0
    },
    tabs: [
      {
        key: TAB_KEY,
        title: translate(`${NS}.new_subcontractor`),
        apiConfig,
        afterSave: redirectToDetails,
        // The status dropdown is hidden while creating, but a payload that does carry
        // one has to speak the backend's `is_active`.
        modifyDataBeforeSend: ({ copiedData }) => applyProviderStatusToPayload(copiedData),
        // Coordinates come from the address picker, not from a field of their own.
        hiddenFormKeys: [
          'latitude',
          'longitude'
        ],
        tabContent: [
          tabActions.value,
          infoBlock.value
        ]
      }
    ]
  }))
}
